import type { FlagsType } from '@iheartjane/feature-flags';

export const featureFlagProperties = (flags: FlagsType = {}) => {
  return Object.keys(flags).reduce<FlagsType>((allFlags, flag) => {
    allFlags[`Flag_${flag}`] = flags[flag];
    return allFlags;
  }, {});
};
